import { RadPromiseLike } from "../../Extensions";
import { IPromisePublic, PromiseHelper } from "../../Helpers/PromiseHelper";
import { PropertyChange } from "../../PropertyChange";
import { Property } from "../../RadObject";
import { IDialogResponse } from "../Dialogs/IDialogResponse";
import { ElementRef } from "../ElementRef";
import { JsxFragment } from "../JsxFragment";
import { ButtonStyleEnum } from "./ButtonStyleEnum";
import { Dialog, DialogPropertyValues, IDialog } from "./Dialog";
import { NAMESPACE } from "./_Namespace";

interface MessageQueueItem { properties: { title: string, text: string, buttonStyle: ButtonStyleEnum }, promise: IPromisePublic<IDialogResponse> }

export type MessageDialogPropertyValues =
    DialogPropertyValues
    & {
    };

export type MessageDialogProperties = {
    [name in keyof MessageDialogPropertyValues]: Property<MessageDialogPropertyValues[name]>
};

export interface IMessageDialog extends IDialog, MessageDialogProperties
{
}

let
    messageDialog: MessageDialog,
    messageQueue: MessageQueueItem[] = [];

function checkQueue()
{
    if (!messageDialog)
        messageDialog = new MessageDialog();

    if (!messageDialog.opened && messageQueue.length)
    {
        let
            item: MessageQueueItem | undefined;

        while (item == undefined && messageQueue.length)
            item = messageQueue.shift();

        if (item)
        {
            messageDialog.buttonStyle.set(item.properties.buttonStyle);
            messageDialog.text.set(item.properties.text);
            messageDialog.title.set(item.properties.title);

            messageDialog.openAsync()
                .then((...args) => { item?.promise.resolve.apply(item.promise, args); })
                .catch(error => { item?.promise.reject(error); })
                .finally(() => { checkQueue(); });
        }
    }
}

export class MessageDialog extends Dialog implements IMessageDialog
{
    // #region Static

    public static override classNamespace = NAMESPACE + "MessageDialog";
    public static override className = "MessageDialog";

    // #region Public Methods

    public static displayMessage(title: string, text: string, buttonStyle?: ButtonStyleEnum): RadPromiseLike<IDialogResponse>
    {
        const
            promise = PromiseHelper.createPromisePublic<IDialogResponse>();

        messageQueue.push({
            properties: {
                buttonStyle: buttonStyle ?? ButtonStyleEnum.okOnly,
                text: text,
                title: title
            },
            promise: promise
        });

        checkQueue();

        return promise;
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Global Variables

    protected _textElementRef!: ElementRef;

    // #endregion

    // #region Properties

    // #endregion

    // #region Constructor

    // #endregion

    // #region Public Methods

    // #endregion

    // #region Protected Methods

    // #endregion

    // #region Private Methods

    // #endregion

    // #region Overrides

    protected override __initializeProperties(propertyValues: MessageDialogPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this._textElementRef = new ElementRef();
    }

    protected override _createElementHtml(children?: JsxFragment | string | (JsxFragment | string | undefined)[])
    {
        return (
            <div class="rad-control rad-control-container-control rad-control-page">
                <div ref={this._containerWrapperElementRef} class="rad-control-container-wrapper">
                    <div ref={this._containerInnerWrapperElementRef} class="rad-control-container-inner-wrapper">
                        {this._createHeaderHtml()}
                        <div ref={this._containerElementRef} class="rad-control-container ui container fluid">
                            <p ref={this._textElementRef}></p>
                            {children ?? this._createChildrenHtml()}
                        </div>
                    </div>
                </div>
                {this._createFooterHtml()}
            </div>
        );
    }
    protected override _textChanged(change: PropertyChange<string>)
    {
        super._textChanged(change);

        this._textElementRef.current.text(change.currentValue);

        if (change.currentValue?.length)
            this._textElementRef.current.show();
        else
            this._textElementRef.current.hide();
    }

    // #endregion

    // #region Event Handlers

    // #endregion

    // #endregion
}